// Contact showing the users contact info
import React from "react";

const Contact: React.FC = () => {
  return (
    <>
      <div className="w-full flex flex-col items-center justify-center">
        <h1 className="text-3xl font-bold">Contact Me</h1>
        <p className="text-lg">
          Reach out to me at {" "}
          <a
            href="mailto:naterfute@proton.me"
            target="_blank"
            rel="noreferrer"
            className="text-accent hover:text-red-700"
          >
            naterfute@proton.me
          </a>{" "}
        </p>
      </div>
    </>
  );
};

export default Contact;
